import React from 'react';
import PropTypes from 'prop-types';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import DemographicsLocationTable from
  'dyzio-shared-components/lib/components/demographics-location-table';

const FullCityModal = ({
  onToggle,
  audienceCities,
}) =>
  <DyzioModal
    headerText="Fans by City"
    size="small"
    onClose={onToggle}
    hasCloseButton
  >
    <DemographicsLocationTable
      data={audienceCities.data}
      metric="absolute"
      metricLabel="Followers"
      itemLabel="City"
      rowsToShow={-1}
    />
  </DyzioModal>;

FullCityModal.propTypes = {
  onToggle: PropTypes.func.isRequired,
  audienceCities: PropTypes.object.isRequired,
};

export default FullCityModal;



/** WEBPACK FOOTER **
 ** ./src/components/facebook-profile-data-large/full-city-modal.js
 **/